export default __webpack_public_path__ + "static/folder-0eadeabbb594edae22ae04fc816d3d67.png";